module.exports = __webpack_public_path__ + "img/info.cc01fdc1.jpg";